enum MediaType {
  Picture = 'picture',
  Video = 'video',
}

export const getMediaType = (file: File): MediaType => {
  const mimeType = file.type.toLowerCase();

  if (mimeType.startsWith('video/')) {
    return MediaType.Video;
  }

  if (mimeType.startsWith('image/')) {
    return MediaType.Picture;
  }

  throw new Error('Unsupported media type');
};
